import styled from '@emotion/styled';
import React from 'react';
import CheckCircleIcon from '../../svg/ContiUpgrade/CheckCircleIcon';
import { RichTextRenderer } from '../RichTextRenderer';

const StyledContiWrapper = styled.div`
	> div:first-of-type {
		margin: -20px;
	}

	.dmlp__conti-upgrade__cta {
		position: sticky;
		bottom: 0;
		background: white;
		padding: 10px 0 20px;
	}
`;

const StyledContiBenefits = styled.div``;

const ContiUpgradeBenefits = ({ title, copy, brand }) => {
	return (
		<StyledContiBenefits className='d-flex justify-content-start align-items-start mb-20 conti-upgrade__benefit'>
			<div className='mr-12 conti-upgrade__benefit__icon'>
				<CheckCircleIcon
					color={
						brand === 'vir'
							? '#512698'
							: brand === 'adc'
							? '#F15B46'
							: '#117B53'
					}
				/>
			</div>
			<div>
				<div className='subtitle mb-4 lower roboto conti-upgrade__benefit__title'>
					{title}
				</div>
				<div className='conti-upgrade__benefit__copy'>{copy}</div>
			</div>
		</StyledContiBenefits>
	);
};

const ContiUpgrade = ({
	brand = '',
	handleContiUpgrade,
	contiDetails,
	lpDefaults = {},
}) => {
	let { video, image, title, ctaCopy, ctaOfferCopy, tc, benefits } =
		contiDetails;
	const { lpContiBenefits, lpContiVideo, lpContiTC } = lpDefaults;
	const items =
		(benefits?.items || []).length > 0
			? benefits?.items
			: lpContiBenefits?.items;

	/**
	 * Added Adobe DL event after click on yes or no button
	 */
	const onClickYesOrNoForAdobeDL = (type) => {
		var AdobeDLClickEventObj = {};
		if (type === 'Yes') {
			AdobeDLClickEventObj = {
				clickEvent: 'rec:checkout:ug:popup:yes',
				clickDescription: 'rec:checkout:ug:popup:yes',
				name: 'Click yes on upgrade to wine plan pop up',
				clickLocation: 'rec checkout upgrade',
				clickText: type,
				clickAction: 'Click yes',
			};
		} else {
			AdobeDLClickEventObj = {
				clickEvent: 'rec:checkout:ug:popup:no',
				clickDescription: 'rec:checkout:ug:popup:no',
				name: 'Click no thanks on upgrade to wine plan pop up',
				clickLocation: 'rec checkout upgrade',
				clickText: type,
				clickAction: 'Click no thanks',
			};
		}

		// eslint-disable-next-line no-undef
		AdobeDLFunctions.clickEventDL(
			AdobeDLClickEventObj.clickEvent,
			AdobeDLClickEventObj
		);
	};

	return (
		<StyledContiWrapper>
			<div className='conti-upgrade'>
				<h5 className='font-weight-bold mt-0 mb-20 text-center conti-upgrade__title'>
					{title
						? title
						: 'Want access to delicious wines at fabulous prices every time?'}
				</h5>

				{image ? (
					<div className='mb-20 conti-upgrade__image'>
						<img src={image} alt='Conti Upgrade' className='img-responsive' />
					</div>
				) : (
					<div className='dmlp__conti-upgrade__video conti-upgrade__video mb-20 position-relative'>
						<iframe
							className='w-100 position-absolute h-100'
							src={video || lpContiVideo}
							frameBorder='0'
							allowFullScreen
							allow='autoplay'
						></iframe>
					</div>
				)}

				<h5 className='font-weight-bold mt-0 mb-20 text-center lower conti-upgrade__benefits-title'>
					Look forward to more...
				</h5>

				{items.length > 0 ? (
					<StyledContiBenefits>
						{items.map((item, index) => {
							let { title, description } = item;
							if (title && description) {
								return (
									<ContiUpgradeBenefits
										key={index}
										title={title}
										copy={description}
										brand={brand}
									/>
								);
							}
						})}
					</StyledContiBenefits>
				) : null}

				<div className='dmlp__conti-upgrade__cta'>
					{/* <div className='mb-16 dmlp__conti-upgrade__cta__title font-weight-bold text-center'>
						Take a further $30 off today’s price when you sign up now!
					</div> */}
					<button
						type='button'
						className={`btn btn-${
							brand === 'adc' ? 'green' : 'primary'
						} w-100 mb-12 conti-upgrade__yes-btn ${brand}`}
						onClick={() => {
							handleContiUpgrade(true);
							onClickYesOrNoForAdobeDL('Yes');
						}}
					>
						<span className='font-weight-bold d-block pb-4 text-uppercase'>
							{ctaCopy ? ctaCopy : 'Yes Please!'}
						</span>
						<span className='d-block font-weight-normal'>
							{ctaOfferCopy
								? ctaOfferCopy
								: 'Take a further $30 off today’s price'}
						</span>
					</button>
					<div
						className={
							'btn btn-secondary btn-block bg text-center p-12 font-weight-normal conti-upgrade__no-btn ' +
							brand
						}
						onClick={() => {
							handleContiUpgrade(false);
							onClickYesOrNoForAdobeDL('No');
						}}
					>
						No thanks, place my order
					</div>
				</div>

				{/* <div className='dmlp__conti-upgrade__tc-title mb-8 pt-20'>
					Terms & Conditions
				</div> */}
				<div className='dmlp__conti-upgrade__tc mb-20'>
					{tc?.content && tc?.content.length > 0 ? (
						<RichTextRenderer content={tc} />
					) : (
						<div dangerouslySetInnerHTML={{ __html: lpContiTC }} />
					)}
				</div>
			</div>
		</StyledContiWrapper>
	);
};

export default ContiUpgrade;
